(function () {
	'use strict';

	/**
	 * @ngdoc component
	 * @name mx.components:mxStepper
	 * @module mx.components
	 * @restrict 'E'
	 * @description
	 * The mx-stepper control show how to use material stepper
	 *
	 * The example below demonstrates some of the attributes you may use with the mxStepper control:
	 *
	 * @param {object[]} steps= - Array of defined steps where each `step` contains following properties:
	 *
	 *  - `title` - {string} - The title of the step;
	 *  - `date` - {date} - The date of the previous step;
	 *  - `active` - {boolean} - step activity;
	 *  - `description` - {string} - The details of step;
	 *  - `status` - {string} - The name of the step state;
	 *  - `icon` - {string} - Material icon name.
	 *  - `steps` - {object[]} - Children steps (one level steps).
	 * @param {string} direction= - type of direction `vertical` or `horizontal`. Default: `vertical`
	 * @usage
	 *        <mx-stepper
	 *            data-steps='[
	 *            { Title:"0", Date:null, Active:true, Declined: true, Description:"details1", Status:"", Icon: "done", Steps: [] },
	 *            { Title:"1", Date:null, Description:"details2", Status: "Pending", Steps: [] }
	 *            ]'
	 *            direction='vertical'
	 *        >
	 *        </mx-stepper>
	 */

	angular.module('mx.components').component('mxStepper', {
		scope: {},
		bindings: {
			steps: '=?',
			config: '=?',
			direction: '@',
		},
		transclude: true,
		templateUrl: 'mx-stepper/mx-stepper.html',
		controller: MxStepperCtrl,
		controllerAs: '__$vm',
	});

	MxStepperCtrl.$inject = ['mx.internationalization', '$element'];
	function MxStepperCtrl(i18n, $element) {
		var vm = this;
		var _steps = null;

		setSteps(vm.steps);

		vm.$onInit = function () {
			vm.ready = false;
			vm.init();

			vm.imgHost = (vm.config || {}).attachments || '';
		};

		vm.$doCheck = function () {
			if ($element.closest('mx-side-panel').closest('.mx-side-layout-full-screen-mode').length === 0) {
				var stepperContainer = $element.find('.stepper');
				if (stepperContainer[0] && stepperContainer[0].offsetWidth < getMaxMobileOffset(100)) {
					stepperContainer.addClass('stepper-mobile');
				} else {
					stepperContainer.removeClass('stepper-mobile');
				}
			} else {
				$element.find('.stepper').removeClass('stepper-mobile');
			}
		};

		Object.defineProperty(vm, 'steps', {
			get: function () {
				return _steps;
			},
			set: function (value) {
				if (value && value.length > 0) {
					//} && !vm.ready) {
					vm.ready = true;
					setSteps(value);
					vm.init();
				}
			},
		});

		function getMaxMobileOffset(stepLength) {
			if (vm.steps && vm.steps.length) {
				var padding = 5;
				return vm.steps.length * stepLength + (vm.steps.length - 1) * padding;
			}
		}

		function setSteps(value) {
			value = value || [];
			adjustStepsRecursively(value, null);
			_steps = value;
		}

		function adjustStepsRecursively(steps, parentStep) {
			if (steps && steps.length > 0) {
				var activeStep = _.findIndex(steps, function (step) {
					return step.Active;
				});
				var failedStep = _.findIndex(steps, function (step) {
					return step.Failed;
				});
				for (var stepNumber = 0; stepNumber < steps.length; stepNumber++) {
					var step = steps[stepNumber];
					step.stateClass = null;
					step.hasChildren = step.Steps && step.Steps.length && step.Steps.length > 0;
					step.isLastChild = false;
					step.finishDate = step.Date ? i18n.formatUTCDate(step.Date, 'shortDate') : null;

					if (stepNumber === activeStep) {
						step.stateClass = 'active';
						step.stepIcon = 'cached';
					} else if ((activeStep === -1 && failedStep === -1) || stepNumber < activeStep || stepNumber < failedStep) {
						step.stateClass = 'completed';
						step.stepIcon = 'done';
					} else if (stepNumber === failedStep) {
						step.stateClass = 'failed';
						step.stepIcon = 'clear';
					} else if (failedStep > -1 && stepNumber > failedStep) {
						step.stateClass = 'post-failed';
						step.stepIcon = 'clear';
					} else {
						step.stepIcon = stepNumber;
					}

					step.previewText = step.Title || '';
					step.descriptionText = step.finishDate;
					step.detailsText = step.Description || '';

					var stateWithDate = '';
					step.statusText = '';

					if (step.Status || (parentStep && parentStep.Status)) {
						stateWithDate = step.statusText = step.Status || parentStep.Status;
					}

					if (step.Description) {
						if (!step.statusText) {
							step.statusText = step.Description;
						} else if (!step.descriptionText) {
							step.descriptionText = step.Description;
						}
					}

					if (step.finishDate) {
						if (stateWithDate) {
							stateWithDate += ' - ';
						}
						stateWithDate += step.finishDate;
					}

					if (stateWithDate) {
						if (step.detailsText) {
							step.detailsText += ' - ';
						}
						if (step.previewText) {
							step.previewText += ' - ';
						}

						step.detailsText += stateWithDate;
						step.previewText += stateWithDate;
					}

					if (step.Description) {
						step.previewText += ' - ' + step.Description;
					}

					if (step.hasChildren) {
						adjustStepsRecursively(step.Steps, step);
					}
				}
				steps[stepNumber - 1].isLastChild = true;
			}
		}

		vm.init = function () {};

		vm.close = function (elem) {
			$(elem.currentTarget).parent().hide();
			$('.stepper').find('.step-content').css('float', 'none');
		};

		vm.getStepDetails = function (elem) {
			var stepContent = $(elem.currentTarget).next();
			var stepContentWrapper = stepContent.next();

			var isHidden = $(stepContentWrapper).css('display') === 'none';
			var stepper = $('.stepper');
			stepper.find('.step-content').css('float', 'none');
			stepper.find('.step-content-wrapper').css('display', 'none');

			if (isHidden) {
				stepContentWrapper.show();
				stepContent.css('float', 'left');
			}
		};
	}
})();
